// extracted by mini-css-extract-plugin
export default {"mainFooter":"Footer_mainFooter__d0h2a"};